"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInternalJobAction = exports.EProductShape = exports.EInvoiceType = exports.EProductionStatus = exports.EOrderStatus = exports.ALL_COLORS = exports.EColor = exports.ECurrency = exports.ELanguage = void 0;
var ELanguage;
(function (ELanguage) {
    ELanguage["en"] = "en";
    ELanguage["us"] = "us";
    ELanguage["de"] = "de";
    ELanguage["fr"] = "fr";
    ELanguage["nl"] = "nl";
})(ELanguage = exports.ELanguage || (exports.ELanguage = {}));
var ECurrency;
(function (ECurrency) {
    ECurrency["euro"] = "euro";
    ECurrency["usdollar"] = "usdollar";
})(ECurrency = exports.ECurrency || (exports.ECurrency = {}));
var EColor;
(function (EColor) {
    EColor["black"] = "Black";
    EColor["white"] = "White";
    EColor["extraWhite"] = "Extra White";
    EColor["nordicWhite"] = "Nordic White";
    EColor["cork"] = "Cork";
    EColor["grey"] = "Grey";
    EColor["newGrey"] = "New Grey";
    EColor["red"] = "Red";
    EColor["blue"] = "Blue";
})(EColor = exports.EColor || (exports.EColor = {}));
exports.ALL_COLORS = [
    EColor.black,
    EColor.white,
    EColor.extraWhite,
    EColor.nordicWhite,
    EColor.grey,
    EColor.newGrey,
    EColor.black,
    EColor.blue,
    EColor.cork,
    EColor.red,
];
var EOrderStatus;
(function (EOrderStatus) {
    EOrderStatus["offer"] = "offer";
    EOrderStatus["pending"] = "pending";
    EOrderStatus["order"] = "order";
    EOrderStatus["archived"] = "archived";
    EOrderStatus["canceled"] = "canceled";
})(EOrderStatus = exports.EOrderStatus || (exports.EOrderStatus = {}));
var EProductionStatus;
(function (EProductionStatus) {
    EProductionStatus["unplanned"] = "unplanned";
    EProductionStatus["planned"] = "planned";
    EProductionStatus["modeled"] = "modeled";
    EProductionStatus["baked"] = "baked";
    EProductionStatus["broken"] = "broken";
    EProductionStatus["sent"] = "sent";
})(EProductionStatus = exports.EProductionStatus || (exports.EProductionStatus = {}));
var EInvoiceType;
(function (EInvoiceType) {
    EInvoiceType["advance"] = "advance";
    EInvoiceType["saldo"] = "saldo";
    EInvoiceType["credit"] = "credit";
})(EInvoiceType = exports.EInvoiceType || (exports.EInvoiceType = {}));
var EProductShape;
(function (EProductShape) {
    EProductShape["round"] = "round";
    EProductShape["square"] = "square";
    EProductShape["rectangle"] = "rectangle";
    EProductShape["irregular"] = "irregular";
})(EProductShape = exports.EProductShape || (exports.EProductShape = {}));
var EInternalJobAction;
(function (EInternalJobAction) {
    EInternalJobAction["SYNC_ORDER_STATUS"] = "SYNC_ORDER_STATUS";
    EInternalJobAction["SYNC_PRODUCT_STOCK"] = "SYNC_PRODUCT_STOCK";
})(EInternalJobAction = exports.EInternalJobAction || (exports.EInternalJobAction = {}));
//# sourceMappingURL=types.js.map